<template>
  <div
    class="ant-pro-table-list-toolbar"
    v-if="!config?.hide_header"
    ref="headerRef"
  >
    <div class="ant-pro-table-list-toolbar-container">
      <div class="ant-pro-table-list-toolbar-left">
        <slot name="header_bar_before_title"></slot>
        <div class="ant-pro-table-list-toolbar-title">
          <span v-if="config?.show_title">{{ config?.title }}</span>
          <div
            v-if="config?.show_current_view"
            class="current-view-container"
          >
            <a-tooltip
              v-if="currentView?.name"
              :title="'视图：' + currentView?.name"
            >
              <span class="current-view-name">
                {{ currentView?.name }}
              </span>
            </a-tooltip>
            <template v-if="enableEditCurrentView">
              <span style="font-size: 12px; margin-right: 5px; display: inline-block">
                (已编辑)
              </span>
              <a-dropdown
                v-model:open="isDropdown"
                trigger="click"
              >
                <span class="view-menu">
                  {{ $t('保存') }}
                  <down-outlined
                    v-if="!isDropdown"
                    style="font-size: 10px; cursor: pointer"
                  />
                  <up-outlined
                    v-if="isDropdown"
                    style="font-size: 10px; cursor: pointer"
                  />
                </span>
                <template #overlay>
                  <a-menu>
                    <a-menu-item>
                      <span
                        @click="
                          () => {
                            isDropdown = false;
                            selfEventBus.emit('saveView');
                          }
                        "
                      >
                        {{ $t('保存视图') }}
                      </span>
                    </a-menu-item>
                    <a-menu-item>
                      <span
                        @click="
                          () => {
                            isDropdown = false;
                            selfEventBus.emit('saveNewView');
                          }
                        "
                      >
                        {{ $t('另存为新视图') }}
                      </span>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
              <span
                :bordered="false"
                class="view-menu"
                @click="
                  () => {
                    selfEventBus.emit('reinit');
                  }
                "
              >
                {{ $t('重置') }}
              </span>
            </template>
          </div>
        </div>
        <slot name="header_bar_after_title"></slot>
      </div>
      <div class="ant-pro-table-list-toolbar-right">
        <a-space align="center">
          <slot name="header_bar_before_btn"></slot>
          <head-btn
            :auth_batch_update_list="auth_batch_update_list"
            :auth_head_btn_list="auth_head_btn_list"
            :selectedRowKeys="selectedRowKeys"
            :dataSource="dataSource"
            :searchConfig="config.query_params || {}"
            :current_org="current_org"
            :router="router"
            :event_obj="selfEventBus"
          />
          <slot name="header_bar_after_btn"></slot>
        </a-space>

        <div class="ant-pro-table-list-toolbar-divider">
          <a-divider type="vertical" />
        </div>

        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="component_type === 'normal' && config?.condition_group_config_list?.length > 0"
        >
          <ConditionGroupSelecter
            :config="config"
            :selfEventBus="selfEventBus"
            v-model:selectedConditionGroup="selectedConditionGroup"
            v-model:groupConditionValue="groupConditionValue"
            @change="handleSelectedConditionGroupChange"
          />
        </div>
        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="config?.sys_btn?.refresh !== false"
        >
          <refresh-type-modal
            :refreshType="refreshType"
            :loading="loading"
            @refresh="$emit('refresh')"
            @typeChange="$emit('refreshTypeChange', $event)"
          />
        </div>
        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="
            (component_type === 'normal' || component_type === 'pivot_table') &&
            config?.sys_btn?.export !== false
          "
        >
          <a-tooltip :title="$t('导出Excel')">
            <a-button
              type="text"
              size="small"
              @click="$emit('export')"
            >
              <template #icon>
                <download-outlined></download-outlined>
              </template>
            </a-button>
          </a-tooltip>
        </div>
        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="component_type === 'normal' && config?.sys_btn?.table_size !== false"
        >
          <a-tooltip :title="$t('密度')">
            <a-dropdown
              :trigger="['click']"
              placement="bottomRight"
            >
              <column-height-outlined />
              <template #overlay>
                <a-menu
                  :selected-keys="[tableSize]"
                  style="width: 80px"
                  @click="
                    ({ key }) => {
                      $emit('update:tableSize', key as string);
                      $emit('tableSizeChange', key as string);
                    }
                  "
                >
                  <a-menu-item key="default">
                    <a href="javascript:">{{ $t('默认') }}</a>
                  </a-menu-item>
                  <a-menu-item key="middle">
                    <a href="javascript:">{{ $t('中等') }}</a>
                  </a-menu-item>
                  <a-menu-item key="small">
                    <a href="javascript:">{{ $t('紧凑') }}</a>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </a-tooltip>
        </div>
        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="config?.sys_btn?.column_config !== false"
        >
          <a-tooltip :title="$t('设置')">
            <a-button
              type="text"
              size="small"
              @click="settingOpen = true"
            >
              <template #icon>
                <setting-outlined />
              </template>
            </a-button>
          </a-tooltip>
        </div>

        <div
          class="ant-pro-table-list-toolbar-setting-item"
          v-if="config?.sys_btn?.full_screen !== false"
        >
          <a-tooltip :title="screenState ? $t('退出全屏') : $t('全屏')">
            <fullscreen-outlined
              v-if="!screenState"
              @click="$emit('setFull')"
            />
            <fullscreen-exit-outlined
              v-else
              @click="$emit('exitFull')"
            />
          </a-tooltip>
        </div>
      </div>
    </div>
  </div>
  <!--
    分组标签区高度不固定（标签换行，最高 156px），必须单独观察后合并计入 header 高度，
    否则 tablePro 的 tableHeight 会漏算这块高度导致表格溢出。
  -->
  <div ref="conditionGroupRef">
    <ConditionGroupView
      :config="config"
      v-model:conditionGroupDataList="conditionGroupDataList"
      v-model:selectedConditionGroup="selectedConditionGroup"
      :selfEventBus="selfEventBus"
      v-model:groupConditionValue="groupConditionValue"
      @change="handleGroupConditionValueChange"
    />
  </div>
  <template v-if="settingMode === 'drawer'">
    <a-drawer
      :title="$t('设置')"
      :width="settingDrawerWidth"
      :placement="settingDrawerPlacement"
      v-model:open="settingOpen"
      :mask="component_type === 'normal' ? true : false"
      :push="false"
    >
      <column-edit-view
        :columns="columns"
        :is_view="is_view"
        :view_key="view_key"
        :view_flag_name="view_flag_name"
        :component_type="component_type"
        :pivotConfig="localPivotConfig"
        :pivotChartsConfig="localPivotChartsConfig"
        :settingMode="settingMode"
        :settingDrawerWidth="settingDrawerWidth"
        :settingDrawerPlacement="settingDrawerPlacement"
        @change="$emit('columnsChange', $event)"
        @pivotConfigChange="onPivotConfigChange"
        @pivotChartsConfigChange="onPivotChartsConfigChange"
      ></column-edit-view>
    </a-drawer>
  </template>
  <a-modal
    v-else
    :title="$t('设置')"
    width="900px"
    :body-style="{ height: 'calc(100vh - 250px)' }"
    v-model:open="settingOpen"
  >
    <column-edit-view
      :columns="columns"
      :is_view="is_view"
      :view_key="view_key"
      :view_flag_name="view_flag_name"
      :component_type="component_type"
      :settingMode="settingMode"
      :pivotConfig="localPivotConfig"
      :pivotChartsConfig="localPivotChartsConfig"
      :settingDrawerWidth="settingDrawerWidth"
      :settingDrawerPlacement="settingDrawerPlacement"
      @change="$emit('columnsChange', $event)"
      @pivotConfigChange="onPivotConfigChange"
      @pivotChartsConfigChange="onPivotChartsConfigChange"
    ></column-edit-view>
    <template #footer>
      <a-button @click="settingOpen = false">
        {{ $t('关闭') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import {
  ColumnHeightOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  DownloadOutlined,
  SettingOutlined,
} from '@ant-design/icons-vue';
import { useResizeObserver } from '@vueuse/core';
import { computed, ref, watch } from 'vue';
import columnEditView from './tableConfig/index.vue';
import HeadBtn from './headBtn.vue';
import RefreshTypeModal from './refresh-type-modal/index.vue';
import {
  Column,
  ConditionGroupConfigItem,
  Table,
  PivotConfig,
  PivotChartsConfig,
  SettingMode,
  SettingDrawerPlacement,
} from './typing';
import { useTableProState } from './utils';
import ConditionGroupSelecter from './ConditionGroupSelecter.vue';
import ConditionGroupView from './ConditionGroupView.vue';
import { useUserStore } from 'liyu-pc-base/init-plugin';
import { cloneDeep } from 'lodash';

interface Props {
  config?: Table;
  auth_batch_update_list?: any[];
  auth_head_btn_list?: any[];
  selectedRowKeys?: any[];
  dataSource?: any[];
  current_org?: any;
  router?: any;
  selfEventBus?: any;
  loading?: boolean;
  screenState?: boolean;
  tableSize?: string;
  columns?: Column[];
  view_key?: string;
  view_flag_name?: string;
  is_view?: boolean;
  refreshType?: string;
  conditionsParams?: any;
  pivotConfig?: PivotConfig | null;
  pivotChartsConfig?: PivotChartsConfig | null;
  component_type?: string;
}

const props = withDefaults(defineProps<Props>(), {
  config: () => ({} as Table),
  auth_batch_update_list: () => [],
  auth_head_btn_list: () => [],
  selectedRowKeys: () => [],
  dataSource: () => [],
  loading: false,
  screenState: false,
  tableSize: 'small',
  columns: () => [],
  view_key: '',
  view_flag_name: '',
  is_view: true,
  refreshType: '手动',
  conditionsParams: () => null,
  pivotConfig: () => null,
  pivotChartsConfig: () => null,
  component_type: 'normal',
});

const emit = defineEmits([
  'refresh',
  'export',
  'setFull',
  'exitFull',
  'columnsChange',
  'pivotConfigChange',
  'pivotChartsConfigChange',
  'viewSelected',
  'update:tableSize',
  'heightChange',
  'refreshTypeChange',
  'tableSizeChange',
  'selectedConditionGroupChange',
  'groupConditionValueChange',
]);
const settingOpen = defineModel('settingOpen', {
  default: false,
});
const userStore = useUserStore();
const current_org = userStore.currentOrg;
const VIEW_SYSTEM_EDIT = 'view_system_edit';
const is_view_system_edit_auth = ref(userStore.CHECK_AUTH(VIEW_SYSTEM_EDIT));
const enableEditCurrentView = computed(() => {
  if (currentView.value?.is_other_user_view) {
    return false;
  }
  if (currentView.value?.is_system && !is_view_system_edit_auth.value) {
    return false;
  }
  return isViewChange.value && currentView.value && currentView.value.id !== 'no-view';
});
const selectedConditionGroup = defineModel('selectedConditionGroup', {
  default: null,
});
const conditionGroupDataList = defineModel<any[]>('conditionGroupDataList', {
  default: null,
});
const groupConditionValue = defineModel('groupConditionValue', {
  default: null,
});
// 「设置」弹窗交互方式：modal（模态框，默认）或 drawer（抽屉）
const settingMode = computed<SettingMode>(() => props.config?.setting_mode || 'modal');
const settingDrawerWidth = computed<string | number>(
  () => props.config?.setting_drawer_width ?? '700px',
);
const settingDrawerPlacement = computed<SettingDrawerPlacement>(
  () => props.config?.setting_drawer_placement || 'left',
);
const headerRef = ref(null);
/**
 * header 整体高度 = 工具栏（.ant-pro-table-list-toolbar）高度 + 分组标签区（ConditionGroupView）高度。
 * 分组标签会随数据换行，高度不固定，必须单独观察；两者相加后才能给 tablePro 正确的 tableHeight。
 */
const conditionGroupRef = ref(null);
const toolbarHeight = ref(0);
const conditionGroupHeight = ref(0);
const emitHeightChange = () => {
  emit('heightChange', toolbarHeight.value + conditionGroupHeight.value);
};
useResizeObserver(headerRef, entries => {
  toolbarHeight.value = entries[0].contentRect.height;
  emitHeightChange();
});
useResizeObserver(conditionGroupRef, entries => {
  conditionGroupHeight.value = entries[0].contentRect.height;
  emitHeightChange();
});
const { currentView, isViewChange } = useTableProState();
const isDropdown = ref(false);
const handleSelectedConditionGroupChange = (item: ConditionGroupConfigItem) => {
  emit('selectedConditionGroupChange', item);
};
const handleGroupConditionValueChange = (value: any) => {
  emit('groupConditionValueChange', value);
};

// ============ 数据透视表相关 ============
const localPivotConfig = ref<PivotConfig>(
  props.pivotConfig
    ? cloneDeep(props.pivotConfig)
    : { rows: [], columns: [], values: [], indicatorsAsCol: true, rowHierarchyType: 'grid' },
);

watch(
  () => props.pivotConfig,
  val => {
    if (val) {
      localPivotConfig.value = cloneDeep(val);
    }
  },
  { deep: true },
);

const onPivotConfigChange = (config: PivotConfig) => {
  emit('pivotConfigChange', config);
};

// ============ 数据透视图相关 ============
const localPivotChartsConfig = ref<PivotChartsConfig>(
  props.pivotChartsConfig
    ? cloneDeep(props.pivotChartsConfig)
    : { series: [], category: [], values: [], chartType: 'bar' },
);

watch(
  () => props.pivotChartsConfig,
  val => {
    if (val) {
      localPivotChartsConfig.value = cloneDeep(val);
    }
  },
  { deep: true },
);

const onPivotChartsConfigChange = (config: PivotChartsConfig) => {
  emit('pivotChartsConfigChange', config);
};
</script>

<style lang="less" scoped>
.ant-pro-table-list-toolbar-container {
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
}
.ant-pro-table-list-toolbar-setting-item {
  font-size: 14px;
}
.current-view-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 150px;
}
.current-view-container {
  display: flex;
  height: 100%;
  padding: 2px;
  gap: 4px;
}
.view-menu {
  font-size: 12px;
  font-weight: normal;
  cursor: pointer;
  padding: 0 4px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  line-height: 26px;
}
</style>
